import { Gender } from "../../../lib/apollo/graphql/generated";
import SelectBox from "../../common/components/SelectBox";

interface GenderSelectorProps {
  gender: Gender | null;
  onChange: (newGender: Gender | null) => void;
}

export default function GenderSelector({
  gender,
  onChange,
}: GenderSelectorProps) {
  return (
    <SelectBox
      value={gender ?? ""}
      onSelect={(gender) => {
        if (!gender) {
          onChange(null);
        } else {
          onChange(gender);
        }
      }}
      options={[
        { label: "여성", value: Gender.Female },
        { label: "남성", value: Gender.Male },
      ]}
      className="h-[50px]"
    />
  );
}
